/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import {
  Select,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  SelectInput,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { codeOk, errorMessage, pushCountry } from "../../lib/index";
import { useCountryContext } from "../../context/CountryContext";
import { useTourPackageContext } from "../../context/TourPackageContext";
import { useAgentContext } from "../../context/AgentContext";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { FOLDERS, image_kit_folder } from "../doseeData/utils/Utils";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import { countriesList } from "../components/data";
import { FiBriefcase, FiImage, FiUser, FiCreditCard } from "react-icons/fi";

const Add = () => {
  const { createOneAgent } = useAgentContext();
  const { countries, fetchCountries } = useCountryContext();
  const { tourPackages, fetchTourPackages } = useTourPackageContext();

  const [fetchedTour, setFetchedTour] = useState<any>(null);

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [title, setTitle] = useState(null);
  const [country, setCountry] = useState("Uganda");
  const [agent_package_id, setAgentPackageId] = useState(0);
  const [agent_payment_id, setAgentPaymentId] = useState(0);
  const [agent_email, setAgentEmail] = useState(null);
  const [agent_phone, setAgentPhone] = useState(null);
  const [agent_contact, setAgentContact] = useState(null);
  const [agent_transactions, setAgentTransactions] = useState(0);
  const [agent_rating, setAgentRating] = useState(0.0);
  const [description, setDescription] = useState(null);

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [thumbnailLogo, setThumbnailLogo] = useState(null);
  const [thumbnailIdLogo, setThumbnailIdLogo] = useState(null);

  const agentRoutes = "/agent";

  useEffect(() => {
    if (!countries) fetchCountries();

    if (!tourPackages) {
      fetchTourPackages();
    } else {
      const this_tour: any[] = [];
      tourPackages.map((tour: any) =>
        this_tour.push({
          name: tour.title,
          id: tour.tour_package_id,
        }),
      );
      setFetchedTour(this_tour);
    }
  }, [countries, tourPackages]);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setAgentEmail(null);
    setAgentPhone(null);
    setAgentContact(null);
    setThumbnail(null);
    setThumbnailId(null);
    setThumbnailLogo(null);
    setThumbnailIdLogo(null);
    setAgentTransactions(0);
    setAgentRating(0.0);
    setTitle(null);
    setDescription(null);
  };

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setErrorMessage(message);
  };

  const addOneAgentHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId || !thumbnailLogo || !thumbnailIdLogo) {
      setLoading(false);
      return responses(true, "Image or Logo Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      agent_package_id: agent_package_id,
      agent_payment_id: agent_payment_id,
      agent_biz_reg_no: title?.replace(/ /g, "-") || "reg-no-agent",
      logo: thumbnailLogo ? thumbnailLogo : defaultImage,
      logo_ref_id: thumbnailIdLogo,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      email_address: agent_email,
      phonenumber: agent_phone,
      contact_person_name: agent_contact,
      country: country ? country : "...",
      number_of_transaction: agent_transactions,
      rating: agent_rating,
      name: title,
      description: description,
    };

    const response = await createOneAgent(data);
    if (response) {
      if (response.data.status === codeOk) {
        cleanFields();
        return responses(true, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={agentRoutes}
      eyebrow="Marketplace • Agents"
      title="Add Agent"
      subtitle="Onboard a travel agent with brand assets, contact and tour package details."
      icon={<FiBriefcase className="h-5 w-5" />}
      loading={loading}
      submitLabel="Add Agent"
      onSubmit={addOneAgentHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Brand Assets"
        hint="Upload an agent profile photo and an official logo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <div>
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
              Agent Profile
            </p>
            <ImageKitUpload
              thumbnail={thumbnail}
              thumbnailId={thumbnailId}
              setThumbnail={setThumbnail}
              setThumbnailId={setThumbnailId}
              folder={image_kit_folder("dosee", FOLDERS.AGENTS)}
            />
          </div>
          <div>
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
              Agent Logo
            </p>
            <ImageKitUpload
              thumbnail={thumbnailLogo}
              thumbnailId={thumbnailIdLogo}
              setThumbnail={setThumbnailLogo}
              setThumbnailId={setThumbnailIdLogo}
              folder={image_kit_folder("dosee", FOLDERS.AGENTS)}
            />
          </div>
        </div>
      </AddSection>

      <AddSection
        title="Country, Phone & Packages"
        hint="Select where the agent operates and which packages they sell."
        icon={<FiCreditCard className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <SelectInput
            title="Country"
            defaultValue={country ? country : null}
            required={true}
            value={country ? country : null}
            options={countries ? countries?.map((x: any) => x?.name) : []}
            onChange={(e: any) => {
              setCountry(e.target.value);

              const pickedCountry = countriesList?.find(
                (_c: any) =>
                  String(_c.name).toLowerCase() ===
                  String(e.target.value).toLowerCase(),
              );

              pushCountry({
                country: {
                  id: pickedCountry?.id,
                  name: pickedCountry?.name,
                  slug: pickedCountry?.name,
                  route: "/admin",
                },
              });
            }}
          />
          <PhoneInput
            phone={agent_phone}
            required={true}
            setPhone={setAgentPhone}
            country={country ? country : ""}
          />
          <Select
            props={{
              id: "tour_package_id",
              title: "Tour Package",
              option:
                fetchedTour !== null && tourPackages !== null
                  ? [...fetchedTour.map((_tour: any) => _tour.name)]
                  : [],
              onChange: (e: any) => {
                const index = e.target.selectedIndex;
                setAgentPackageId(fetchedTour[index].id);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "agent_payment_id",
              title: "Payment Method",
              option: ["Visa", "Cash", "E-Wallet", "Mobile Money"],
              onChange: (e: any) => {
                const index = e.target.selectedIndex;
                setAgentPaymentId(index);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Agent Details"
        hint="Identity, contact person and quick metrics."
        icon={<FiUser className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              value: title ? title : "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "agent_email",
              title: "Agent Email",
              type: "text",
              value: agent_email ? agent_email : "",
              onChange: (e: any) => {
                setAgentEmail(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "agent_contact",
              title: "Agent Contact Person",
              type: "text",
              value: agent_contact ? agent_contact : "",
              onChange: (e: any) => {
                setAgentContact(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "agent_transaction",
              title: "Agent Transactions",
              type: "number",
              value: agent_transactions ? agent_transactions : "",
              onChange: (e: any) => {
                setAgentTransactions(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "agent_rating",
              title: "Agent Rating",
              type: "number",
              value: agent_rating ? agent_rating : "",
              onChange: (e: any) => {
                setAgentRating(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Description"
        hint="A brief overview shown on the agent profile."
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            value: description ? description : "",
            onChange: (e: any) => {
              setDescription(e.target.value);
              setError(null);
              setSuccess(null);
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
